<template>
  <div class="invoice">
    <div class="row">
      <div class="col-7">
        <div class="image">
          <Image_Swiper_Set height="85dvh" width="60dvw" :status="status" />
        </div>
      </div>
      <div class="col-5" style="height: 95dvh !important">
        <div class="row">
          <div class="block">
            <div
              class="d-flex align-items-center justify-content-between mb-4"
              style="margin-left: 2rem; margin-top: 2rem; width: 91%"
            >
              <img
                class="logo"
                src="@/assets/leyon_logo.jpg"
                alt="Leyon Logo"
              />
              <div class="invoice-details text-end">
                <h2 class="bold-text">INVOICE</h2>
                <p
                  style="
                    color: #b5b5b5;
                    font-size: 1rem;
                    font-weight: bold;
                    height: 2rem;
                  "
                >
                  Leyon Supermarket<br />
                  Reg no: 0400-01-080762
                </p>
                <p class="contact-info">
                  <a
                    class="url"
                    href="https://www.leyonsuper.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.leyonsuper.com
                  </a>
                  <span class="separator">|</span>
                  <a class="phone-number" :href="'tel:+818080555044'">
                    +81 80-8055-5044
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="main-table">
          <table
            class="table"
            style="
              text-align: center;
              height: 100% !important;
              background: #100d08;
              margin-bottom: 20px;
            "
          >
            <thead style="height: 2dvh !important">
              <tr>
                <th scope="col" class="col-5">Description</th>
                <th scope="col" class="col-2" style="text-align: center">
                  Qty
                </th>
                <th scope="col" class="col-2" style="text-align: center">
                  Price
                </th>
                <th scope="col" class="col-2" style="text-align: center">
                  Amount
                </th>
              </tr>
            </thead>
            <tbody
              class="product-line"
              style="background: #100d08; overflow-y: auto; overflow-x: hidden"
              ref="productTable"
            >
              <tr v-for="product in products" :key="product.row_id">
                <td
                  class="col-5"
                  style="
                    text-align: left;
                    text-wrap: normal;
                    white-space: nowrap;
                    overflow: hidden;
                  "
                >
                  {{ product.product_name }}
                </td>
                <td class="col-2" style="text-align: center">
                  {{ product.quantity }}
                </td>
                <td class="col-2" style="text-align: -webkit-center">
                  {{ product.price }}.00
                </td>
                <td class="col-2" style="text-align: center">
                  {{ product.productTotalPrice.toFixed(2) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="new-footer d-flex justify-content-between">
          <!-- Left Section: Business/Invoice Details -->
          <div class="footer-left">
            <p><strong>INVOICE DATE:</strong> {{ invoiceDate }}</p>
          </div>

          <!-- Right Section: Totals -->
          <div class="footer-right">
            <p>
              <strong>Sub Total:</strong>
              {{ formatCurrency(totalPrice) }}
            </p>
            <p>
              <strong>Credit card fee:</strong>
              {{ formatCurrency(payment_fee) }}
            </p>

            <h3 class="final-total">
              <span :style="{ color: '#b5b5b5', fontSize: '0.8rem' }">
                <br />
              </span>
              <span
                :style="{
                  color: '#f8b219',
                  fontSize: '2rem',
                  fontWeight: 'bold',
                }"
              >
                {{ formatCurrency(finalTotal) }}
              </span>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Image_Swiper_Set from "@/components/Image_Swiper_Set.vue";
import invoiceMixin from "@/service/invoiceMixin";

export default {
  mixins: [invoiceMixin],
  components: {
    Image_Swiper_Set,
  },
  props: {
    businessBasicDetails: {
      type: Object,
    },
    productsData: {
      type: Array,
    },
  },
  data() {
    return {
      status: "billing",
      invoiceDate: new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
    };
  },
  mounted() {
    console.log("All Products:", this.productsData);
    this.productsData.forEach((product, index) => {
      console.log(`Product ${index + 1}:`, product.product_name);
    });
  },
};
</script>

<style scoped>
.invoice {
  background: #100d08;
  border-color: rgba(255, 250, 250, 0);
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}
.logo {
  width: 15%;
  margin: 10px 0;
}
.image {
  margin-left: 0dvh;
  margin-bottom: 0dvh;
  margin-top: 0dvh;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  border-radius: 3px;
}

.block {
  padding: 5px;
  margin-top: 3dvh;
  justify-content: center;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.name {
  font-size: 2dvh;
  color: #ffffff;
  text-overflow: ellipsis;
  margin-left: 7px;
  margin-top: 1dvh;
  align-items: center;
  font-weight: bold;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}
.contact-info {
  color: #b5b5b5;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin-top: 4px;
}

.url {
  color: #b5b5b5;
  text-decoration: none;
  font-weight: bold;
}

.url:hover .phone-number:hover {
  text-decoration: none;
}

.separator {
  margin: 0 8px;
  color: #ffffff;
}
.phone-number {
  color: #b5b5b5;
  text-decoration: none;
  font-weight: bold;
  font-size: 12px;
}

.bold-text {
  margin-left: 6px;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}
.main-table {
  height: 50%;
}

table {
  width: 100%;
  table-layout: fixed;
}

thead,
tfoot {
  display: table;
  width: 100%;
  table-layout: fixed;
  position: relative;
  background: #100d08;
  text-align: left;
}

tbody {
  display: block;
  height: 40dvh;

  overflow-x: hidden;
}

tbody.product-line {
  display: block;
  height: 45vh;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
}

tbody.product-line::-webkit-scrollbar {
  width: 5px;
}

tbody.product-line::-webkit-scrollbar-thumb {
  background-color: #888;
}

tbody.product-line::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

@media (max-width: 768px) {
  tbody.product-line {
    height: 20vh;
  }
}
@media (min-width: 768px) {
  tbody.product-line {
    height: 42vh;
  }
}
@media (min-width: 820px) and (max-width: 1180px),
  (min-width: 1024px) and (max-width: 1336px),
  (min-width: 912px) and (max-width: 1368px),
  (min-width: 853px) and (max-width: 1280px) {
  tbody.product-line {
    height: 18vh;
  }
}
@media (min-width: 1024px) and (max-width: 1024px) and (max-height: 600px) {
  tbody.product-line {
    height: 60vh;
  }
}
tbody.product-line tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

tfoot tr {
  display: table;
  width: 100%;
  table-layout: auto;
}

.final_total {
  font-size: 3dvh;
  margin-left: 2dvw;
  margin-right: 2dvw;
  margin-bottom: 1dvh !important;
  text-align: center;
  color: #f8b219;
  position: relative;
}

.address {
  white-space: pre-line;
}
table th,
table td {
  background: #100d08;
  border: none !important;
}
table th {
  color: #ffffff !important;
  background: #100d08;
}
table td {
  color: #b5b5b5 !important;
  background: #100d08;
}
.new-footer {
  font-size: 13px;
  padding: 20px;
  background-color: #221e1d;
  color: #b5b5b5;
  display: flex;
  justify-content: space-between;
  border-radius: 10px;
  position: absolute;
  bottom: 8vh;
  width: 40%;
}

.footer-left {
  width: 50%;
}
.footer-right {
  width: 50%;
  text-align: right;
}
.footer-left h4 {
  color: #ffffff;
  margin-bottom: 10px;
  font-size: 1.1rem;
}

.footer-right {
  width: 50%;
  text-align: right;
}

.footer-right p {
  margin: 5px 0;
}

.due-text {
  color: #b5b5b5;
  font-size: 1rem;
}

.total-amount {
  color: #f8b219;
  font-size: 2rem;
  font-weight: bold;
  margin-left: 8px;
}

.table th,
.table td {
  color: #ffffff;
}

.main-table {
  margin-bottom: 20px;
}

.invoice {
  background-color: #100d08;
  padding: 20px;
}
</style>
